import { z } from "zod";
import { PASSWORD_MIN_LENGTH, validatePassword } from "./password";

export const identifierTypeSchema = z.enum(["phone", "email", "adid"]);

export const loginSchema = z.object({
  identifier: z.string().trim().min(1, "请输入手机号、邮箱或 ADID").max(200),
  password: z.string().min(1, "请输入密码").max(200),
  turnstileToken: z.string().max(2048).optional().nullable(),
});

export const setupSchema = z
  .object({
    setupToken: z.string().min(1, "请输入初始化令牌"),
    displayName: z.string().trim().min(1, "请输入姓名").max(80),
    identifierType: identifierTypeSchema,
    identifierValue: z.string().trim().min(1, "请输入登录标识").max(200),
    password: z
      .string()
      .min(PASSWORD_MIN_LENGTH, `密码至少 ${PASSWORD_MIN_LENGTH} 个字符`)
      .max(200),
  })
  .superRefine((value, ctx) => {
    const result = validatePassword(value.password);
    if (!result.ok) {
      ctx.addIssue({
        code: "custom",
        path: ["password"],
        message: `密码还需满足：${result.unmet.join("、")}`,
      });
    }
  });

export const changePasswordSchema = z
  .object({
    currentPassword: z.string().min(1, "请输入当前密码"),
    newPassword: z
      .string()
      .min(PASSWORD_MIN_LENGTH, `密码至少 ${PASSWORD_MIN_LENGTH} 个字符`)
      .max(200),
  })
  .superRefine((value, ctx) => {
    const result = validatePassword(value.newPassword);
    if (!result.ok) {
      ctx.addIssue({
        code: "custom",
        path: ["newPassword"],
        message: `密码还需满足：${result.unmet.join("、")}`,
      });
    }
  });

export const refreshSchema = z.object({
  refreshToken: z.string().min(1).optional(),
});

export type LoginInput = z.infer<typeof loginSchema>;
export type SetupInput = z.infer<typeof setupSchema>;
export type ChangePasswordInput = z.infer<typeof changePasswordSchema>;
